import { supabase } from "@baseline/web/supabase";
import { useQuery } from "@tanstack/react-query";

interface SearchResultItem {
	libraryItemId: string;
	type: string;
	itemType: string;
	title: string;
	summary: string | null;
	url: string | null;
	domain: string | null;
	contentId: string | null;
	documentId: string | null;
	docType: string | null;
	matchedChunkIndex: number | null;
}

interface SearchResponse {
	status: string;
	count: number;
	items: SearchResultItem[];
}

export type { SearchResultItem };

export function useSearch(query: string, options?: { limit?: number }) {
	return useQuery({
		queryKey: ["search", query],
		queryFn: async (): Promise<SearchResultItem[]> => {
			const { data, error } = await supabase.functions.invoke("search", {
				body: { q: query, limit: options?.limit ?? 20 },
			});
			if (error) throw new Error(error.message || "Search failed");
			const response = data as SearchResponse;
			return response.items;
		},
		enabled: query.trim().length >= 2,
		staleTime: 30_000,
	});
}
